import * as React from 'react';
import {DiagramEngine} from '@projectstorm/react-diagrams-core';
import {NodeLinkModel} from "../NodeLinkModel";
import {NodeLinkFactory} from "../NodeLinkFactory";

export interface DefaultLinkSegmentWidgetProps {
    path: string;
    link: NodeLinkModel;
    selected: boolean;
    forwardRef: React.RefObject<SVGPathElement>;
    factory: NodeLinkFactory;
    diagramEngine: DiagramEngine;
    onSelection: (selected: boolean) => any;
    extras: object;

}   

export const LinkSegmentWidget = (props: DefaultLinkSegmentWidgetProps) => {

    const Bottom = React.cloneElement(
        props.factory.generateLinkSegment(
            props.link,
            props.selected || props.link.isSelected(),
            props.path
        ),
        {
            ref: props.forwardRef
        }
    );

    const Top = React.cloneElement(Bottom, {
        strokeLinecap: 'round',
        onMouseLeave: () => {
            props.onSelection(false);
        },
        onMouseEnter: () => {
            props.onSelection(true);
        },
        ...props.extras,
        ref: null,
        'data-linkid': props.link.getID(),
        strokeOpacity: props.selected ? 0.1 : 0,
        strokeWidth: 20,
        fill: 'none',
        onContextMenu: (e:any) => {
            if (!props.link.isLocked()) {
                e.preventDefault();
                props.link.remove();
            }
        }
    });

    return (
        <g>
            {Bottom}
            {Top}
        </g>
    );

}